// @ts-check

/**
 * @function convertStrAva
 * @param {string} name
 * @returns {string}
 */
const convertStrAva = (name) => {
	if (!name || typeof name !== 'string') {
		console.error('In convertStrAva(): Name is not a string');
		return '';
	}

	const words = name.trim().split(/\s+/); // Split on whitespace and trim extra spaces

	let initials = '';

	if (words[0]) {
		initials += words[0][0].toUpperCase();
	}

	if (words[1]) {
		initials += words[1][0].toUpperCase();
	}

	return initials;
};

export default convertStrAva;
